var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"area",class:{ thick: _vm.isThick },on:{"click":_vm.clickEvent}},[_c('div',{staticClass:"bar"}),_c('div',{staticClass:"bar"})])
}
var staticRenderFns = []

export { render, staticRenderFns }